
















import { State } from "vuex-class";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";

import { Evidence, Token } from "@/types";
import BaseToken from "@/components/BaseToken.vue";

@Component({
  components: { BaseToken }
})
export default class EvidencedDocument extends Vue {
  private parsed: any[][] = [];

  @Prop({ required: true })
  private evidences!: Evidence[][];

  @Prop()
  private highlighted!: Evidence | null;

  @State("tokens")
  private tokens!: Token[];

  @State("blocks")
  private blocks!: number[][];

  @Emit("select")
  select(value: Evidence[]) {}

  @Watch("evidences")
  update() {
    this.parsed = this.blocks.map(block =>
      block.reduce((arr: any[], index: number) => {
        if (
          arr.length === 0 ||
          this.evidences[index - 1].length != this.evidences[index].length ||
          !this.evidences[index - 1].every((evidence: Evidence) =>
            this.evidences[index].includes(evidence)
          )
        ) {
          arr.push({
            token: this.tokens[index],
            evidences: this.evidences[index]
          });
        } else {
          const partial = arr[arr.length - 1].token;

          arr[arr.length - 1].token = {
            index: partial.index,
            text: partial.text + partial.delimiter + this.tokens[index].text,
            delimiter: this.tokens[index].delimiter,
            span: [partial.span[0], this.tokens[index].span[1]]
          };
        }

        return arr;
      }, [])
    );
  }

  mounted() {
    this.update();
  }
}
